
export const SOFTLINE_CONST_WWS_POS_SELF_CHECKOUT_CONFIG_KEY = 'self-checkout/config'

